var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-col",
        { staticClass: "card-row" },
        [
          _c("card", {
            attrs: {
              title: "",
              type: "qtdeCadastro",
              value: _vm.totalCadastros
            }
          }),
          _c("card", {
            attrs: {
              title: _vm.municipioMaisCadastros.nome,
              type: "nomeMunicipioMaisCadastros",
              value: _vm.municipioMaisCadastros.total
            }
          }),
          _c("card", {
            attrs: {
              title: _vm.osMaisCadastros.nome,
              type: "numeroOSMaisCadastros",
              value: _vm.osMaisCadastros.total
            }
          }),
          _c("card", {
            attrs: {
              title: _vm.cadastranteMaisCadastros.nome,
              type: "nomeCadastranteMaisCadastros",
              value: _vm.cadastranteMaisCadastros.total
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mb" },
        [
          _vm.tipoGraficoOuTabela === "GRAFICO"
            ? _c("h4", { staticClass: "card-title" }, [_vm._v("Gráfico")])
            : _c("h4", { staticClass: "card-title" }, [_vm._v("Tabela")]),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "vue-horizontal",
                { staticClass: "menu-principal" },
                _vm._l(_vm.itemsMenuPrincipal, function(tab) {
                  return _c("div", { key: tab.nome }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab",
                        class: { selected: _vm.selected === tab.codigo },
                        on: {
                          click: function($event) {
                            return _vm.changeTab(tab)
                          }
                        }
                      },
                      [_vm._v(_vm._s(tab.nome))]
                    )
                  ])
                }),
                0
              )
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c("Filtro", {
                attrs: {
                  isFiltroProcesso: false,
                  isGrafico: _vm.tipoGraficoOuTabela === "GRAFICO"
                },
                on: { search: _vm.pesquisarGraficoTabela }
              })
            ],
            1
          ),
          _vm.tipoGraficoOuTabela === "GRAFICO" && _vm.selected !== "PERIODO"
            ? _c(
                "div",
                { key: "graph", staticClass: "reset" },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _vm.selected !== "PERIODO"
                        ? _c("grafico-relatorios", {
                            key: "not-per",
                            attrs: {
                              dadosLabels: _vm.cadastros,
                              titulo: _vm.titulo
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.selected === "PERIODO"
            ? _c(
                "div",
                {
                  key: "per",
                  staticClass: "periodo-wrapper",
                  class: { mh: _vm.tipoGraficoOuTabela === "GRAFICO" }
                },
                [
                  _c("tabs-periodo", {
                    attrs: { selectedTab: _vm.periodoTab },
                    on: { search: _vm.pesquisarPeriodo }
                  }),
                  _vm.tipoGraficoOuTabela === "GRAFICO"
                    ? _c(
                        "div",
                        { key: "graph-wrapper", staticClass: "graph-wrapper" },
                        [
                          _vm.selected === "PERIODO"
                            ? _c("grafico-relatorios-periodo", {
                                key: "per-graph",
                                attrs: {
                                  dadosLabels: _vm.cadastros,
                                  titulo: _vm.titulo
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tipoGraficoOuTabela === "TABELA"
                    ? _c(
                        "div",
                        { key: "per-table", staticClass: "tabela-wrapper" },
                        [
                          _c("tabela-periodo", {
                            attrs: {
                              cadastros: _vm.cadastros,
                              tipo: _vm.selected,
                              tipoPeriodo:
                                _vm.filtroPesquisaGraficoTabela.tipoPeriodo,
                              total: _vm.totalNoPeriodo
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.tipoGraficoOuTabela === "TABELA" &&
                    _vm.selected !== "PERIODO",
                  expression:
                    "tipoGraficoOuTabela === 'TABELA' && selected !== 'PERIODO'"
                }
              ]
            },
            [
              _c("tabela-principal", {
                attrs: {
                  cadastros: _vm.cadastros,
                  tipo: _vm.selected,
                  tipoPeriodo: _vm.filtroPesquisaGraficoTabela.tipoPeriodo,
                  total: _vm.totalNoPeriodo
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "buttons-radio" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.tipoGraficoOuTabela,
                    callback: function($$v) {
                      _vm.tipoGraficoOuTabela = $$v
                    },
                    expression: "tipoGraficoOuTabela"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "GRAFICO" } }, [
                    _vm._v("Gráfico")
                  ]),
                  _c("el-radio-button", { attrs: { label: "TABELA" } }, [
                    _vm._v("Tabela")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "button-row" },
            [
              _vm.tipoGraficoOuTabela === "TABELA"
                ? _c(
                    "el-button",
                    {
                      staticClass: "primary",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportarCSV("CADASTROS")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fal fa-file-csv" }),
                      _c("span", [_vm._v("  Exportar CSV")])
                    ]
                  )
                : _vm._e(),
              _vm.tipoGraficoOuTabela === "GRAFICO"
                ? _c(
                    "el-button",
                    {
                      staticClass: "primary",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportarImagemGrafico("CADASTROS")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fal fa-file-download" }),
                      _c("span", [_vm._v("  Exportar Imagem")])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.tipoGraficoOuTabela === "TABELA"
            ? _c("app-paginacao", {
                attrs: {
                  total: _vm.totalCadastrosGeral,
                  pagina: _vm.filtroPesquisaGraficoTabela.pagina + 1,
                  tamanhoPagina: 15
                },
                on: { changePage: _vm.changePage }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("h4", { staticClass: "card-title" }, [_vm._v("Processos")]),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c("Filtro", {
                attrs: { isFiltroProcesso: true, isGrafico: false },
                on: { search: _vm.pesquisarProcessos }
              })
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-row",
                { staticClass: "divider table-pointer mb" },
                [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Listagem de processos")
                  ]),
                  _c("listagem-processo", { attrs: { dados: _vm.processos } })
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "button-row" },
                [
                  _c("button-acoes-listagem", {
                    attrs: {
                      acoes: _vm.acoesButton,
                      label: "Exportar Listagem"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("app-paginacao", {
                    staticClass: "margin-top",
                    attrs: {
                      total: _vm.totalProcessos,
                      pagina: _vm.filtroPesquisaProcesso.pagina + 1,
                      tamanhoPagina: 15
                    },
                    on: { changePage: _vm.changePageProcesso }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0337d72c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0337d72c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_reurb/Home.vue
// module id = null
// module chunks = 